function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlassdoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 666.66669,
    height: 666.66669,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5000,2500 C 5000,1119.28 3880.71,0 2500,0 1119.29,0 0,1119.28 0,2500 0,3880.71 1119.29,5000 2500,5000 3880.71,5000 5000,3880.71 5000,2500",
    style: {
      fill: "#31af40",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3162.54,1395.76 H 1395.76 v 0 c 0,-243.94 197.76,-441.69 441.7,-441.69 h 1325.08 v 0 c 243.94,0 441.7,197.75 441.7,441.69 v 0 1813.79 c 0,8.89 -7.21,16.09 -16.1,16.09 h -409.51 c -8.88,0 -16.09,-7.2 -16.09,-16.09 z m 0,2650.17 c 243.94,0 441.7,-197.75 441.7,-441.69 v 0 H 1837.46 V 1790.45 c 0,-8.89 -7.21,-16.1 -16.09,-16.1 h -409.52 c -8.88,0 -16.09,7.21 -16.09,16.1 v 1813.79 0 c 0,243.94 197.76,441.69 441.7,441.69 v 0 h 1325.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path16"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassdoor);
export default __webpack_public_path__ + "static/media/Glassdoor.3375ec18.svg";
export { ForwardRef as ReactComponent };